import { TextPropertyComponent } from '../../ui'

class ListItemComponent extends TextPropertyComponent {}

export default ListItemComponent